/** A pending channel must be accepted before the dialog can claim success. */
export async function saveContactEdit(
  savePending: (() => Promise<boolean>) | undefined,
  saveDetails: () => Promise<unknown>,
): Promise<boolean> {
  if ((await savePending?.()) === false) return false;
  await saveDetails();
  return true;
}
